import {Stack, Typography} from '@mui/material';
import React from 'react';

import {translations} from 'presentation/translations-new';
import {ProductEnum} from 'presentation/constants';
import {
	CcgAns,
	ClinipamAns,
	GndiMinasAns,
	GndiSaoPauloAns,
	HapvidaAns,
	NotredameSaudeAns,
} from '../Logos';
import {StyledANSContainer, StyledTypography} from './styles';
import {ANSTextProps} from './types';

const {ccg, clinipam, gndi, hap, ndiMinas, notredamesaude} = translations['pt-br'].others.operators;

function ANSText({operator}: ANSTextProps) {
	if (operator === ProductEnum.HAP) {
		return (
			<Stack alignItems="center">
				<HapvidaAns height={15} />
				<StyledTypography>{hap}</StyledTypography>
			</Stack>
		);
	}
	if (operator === ProductEnum.CCG) {
		return (
			<Stack alignItems="center">
				<CcgAns height={15} />
				<StyledTypography>{ccg}</StyledTypography>
			</Stack>
		);
	}

	if (operator === ProductEnum.CLINIPAM) {
		return (
			<Stack alignItems="center">
				<ClinipamAns height={15} />
				<StyledTypography>{clinipam}</StyledTypography>
			</Stack>
		);
	}

	if (operator === ProductEnum.GNDI_MINAS) {
		return (
			<Stack alignItems="center">
				<GndiMinasAns height={15} />
				<StyledTypography>{ndiMinas}</StyledTypography>
			</Stack>
		);
	}

	if (operator === ProductEnum.GNDI) {
		return (
			<Stack alignItems="center">
				<GndiSaoPauloAns height={15} />
				<StyledTypography>{gndi}</StyledTypography>
			</Stack>
		);
	}

	if (operator === ProductEnum.NOTREDAME_SAUDE) {
		return (
			<Stack alignItems="center">
				<NotredameSaudeAns height={15} />
				<StyledTypography>{notredamesaude}</StyledTypography>
			</Stack>
		);
	}

	return (
		<StyledANSContainer>
			<Stack alignItems="center">
				<HapvidaAns height={15} />
				<Typography fontSize="0.5rem">{hap}</Typography>
			</Stack>
			<Stack alignItems="center">
				<GndiSaoPauloAns height={15} />
				<Typography fontSize="0.5rem">{gndi}</Typography>
			</Stack>
			<Stack alignItems="center">
				<GndiMinasAns height={15} />
				<Typography fontSize="0.5rem">{ndiMinas}</Typography>
			</Stack>
			<Stack alignItems="center">
				<ClinipamAns height={15} />
				<Typography fontSize="0.5rem">{clinipam}</Typography>
			</Stack>
			<Stack alignItems="center">
				<CcgAns height={15} />
				<Typography fontSize="0.5rem">{ccg}</Typography>
			</Stack>
		</StyledANSContainer>
	);
}

export {ANSText};
